import { render, staticRenderFns } from "./CatalystMenu.vue?vue&type=template&id=5053325f&scoped=true&"
import script from "./CatalystMenu.vue?vue&type=script&lang=ts&"
export * from "./CatalystMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CatalystMenu.vue?vue&type=style&index=0&id=5053325f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053325f",
  null
  
)

export default component.exports